<template>
	<ejs-dropdownlist
		v-if="selectedDocumentId" 
		id="documents"
		:value="selectedDocumentId"
		:data-source="documents"
		:fields="{value: 'id', text: 'fileName'}"
		header-template="<hr>"
		item-template="<span><span>${fileName}</span>${if(isComplete)}<br><span>Document Complete</span>${/if}${if(isDeclined)}<br><span>Document Declined</span>${/if}</span>"
		css-class="dropdownClass documents"
		width="250"
		@update:value="$emit(`update:selectedDocumentId`, $event)"					 
	/>
</template>

<script>
import { DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";

export default {
	components: {
		"ejs-dropdownlist": DropDownListComponent,
	},
	props: {
		documents: { type: Array, required: true },
		selectedDocumentId: { type: Number, required: true },
	},
	emits: [`update:selectedDocumentId`],
};
</script>